<template>
	<nav class="message-nav">
		<ul>
			<li class="message-nav__item">
				<AppButton
					class="message-nav__button"
					modifier="large-primary"
					@click="$emit('input', 'compose')"
				>
					Create
				</AppButton>
			</li>

			<li
				v-for="type in types"
				:key="type"
				class="message-nav__item"
				:class="{'message-nav__item--active' : value === type}"
				@click="$emit('input', type)"
			>
				{{ type }}

				<span
					class="message-nav__unread"
					v-if="type === 'inbox' && unread"
				>
					{{ unread.filter(i => i.type === 'inbox')[0].count }}
				</span>
			</li>

			<li class="divider"></li>

			<li
				v-for="section in filters"
				:key="section"
				class="message-nav__item"
				:class="{'message-nav__item--active' : value === section}"
				@click="$emit('input', section)"
			>
				{{ section }}

                <span
					class="message-nav__unread"
					v-if="unread.filter(i => i.type === section)[0].count > 0"
				>
					{{ unread.filter(i => i.type === section)[0].count }}
				</span>
			</li>
		</ul>
	</nav>
</template>
<script>
export default {
	props: ['value', 'unread'],

	data () {
		return {
			types: ['inbox', 'sent'],
			filters: ['general', 'inquiries', 'reports', 'account cancellation']
		}
	}
}
</script>
<style lang="scss" scoped>
.message-nav {
	background-color: #fff;
	border: .5px solid lighten($default-light, 12%);

	&__item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 1em;
		border-left: 5px solid transparent;
		color: $default;
		cursor: pointer;
		min-width: 15em;
		white-space: nowrap;
		text-transform: capitalize;

		&--active {
			border-color: $primary;
		}

		&--active, &:hover {
			background-color: $primary-light;
		}
	}

	&__unread {
		color: $primary;
	}

	&__button {
		width: 100%;
		margin: 20px 0;
	}

	.divider {
		border-top: 1px solid lighten($default-light, 12%);
		margin: 10px auto;
		width: 80%;
	}
}
</style>
